/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import BaseListView from '../BaseListView';
import { momentTime } from '../../helpers/date_functions';

const formatRemarkMetadata = (remark, timeZoneId) => {
  const parts = [];

  if (remark?.current_user_name) {
    parts.push(`Added by: ${remark.current_user_name}`);
  }

  if (remark?.created_at) {
    const formattedDate = momentTime(
      'MMM D, YYYY hh:mm A',
      remark.created_at,
      timeZoneId
    );
    if (formattedDate) {
      parts.push(`Added at: ${formattedDate}`);
    }
  }

  return parts.length > 0 ? parts.join(' | ') : null;
};

const renderRemarkText = (remark) => (
  <span className="billing-remark-text" style={{ fontWeight: 'bold' }}>
    {remark?.remark}
  </span>
);

const sortRemarksNewestFirst = (remarks) =>
  [...remarks].sort((a, b) => {
    const aTime = a?.created_at ? new Date(a.created_at).getTime() : 0;
    const bTime = b?.created_at ? new Date(b.created_at).getTime() : 0;
    return bTime - aTime;
  });

const renderRemarkMetadata = (remark, timeZoneId) => {
  const metadata = formatRemarkMetadata(remark, timeZoneId);
  if (!metadata) return null;

  return (
    <span
      className="billing-remark-metadata"
      style={{ color: 'rgba(0, 0, 0, 0.75)', fontSize: '12px', fontWeight: 'bold' }}
    >
      {metadata}
    </span>
  );
};

const Remarks = ({ data, timeZoneId }) => {
  if (data) {
    const sortedRemarks = Array.isArray(data) ? sortRemarksNewestFirst(data) : [data];

    return (
      <div className="billing-remarks-list">
        <BaseListView
          size="small"
          bordered
          list={sortedRemarks.map((remark) => ({
            title: renderRemarkText(remark),
            description: renderRemarkMetadata(remark, timeZoneId),
          }))}
          showAvatar={false}
          showDescription
        />
      </div>
    );
  }
  return null;
};

export default Remarks;

Remarks.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape()),
    PropTypes.shape(),
  ]).isRequired,
  timeZoneId: PropTypes.string,
  displayType: PropTypes.string,
  showIcon: PropTypes.bool,
};

Remarks.defaultProps = {
  timeZoneId: null,
  displayType: 'line',
  showIcon: false,
};

